<template>
	<div v-bind="$attrs" class="relative">
		<hr class="mb-4 w-full" />
		<div v-if="!showContentLoader" class="flex w-full flex-col gap-3">
			<span class="font-medium text-gray-650">Quick search</span>

			<div class="flex justify-between gap-2">
				<ConditionFilterToggle
					label="All"
					:desc="totalVehiclesCountLabel"
					:is-selected="isConditionAll"
					@on-selected="getSelected"
				/>

				<ConditionFilterToggle
					v-if="!partnerName"
					label="New"
					:desc="totalNewVehiclesCountLabel"
					:is-selected="isConditionNew"
					@on-selected="getSelected"
				/>

				<ConditionFilterToggle
					v-if="!partnerName"
					label="Used"
					:desc="totalUsedVehiclesCountLabel"
					:is-selected="isConditionUsed"
					@on-selected="getSelected"
				/>

				<ConditionFilterToggle
					v-if="partnerName"
					label="EV only"
					:desc="totalEvCountLabel"
					:is-selected="isFuelTypeEv"
					@on-selected="getSelected"
				/>
			</div>
		</div>
		<div v-else class="flex flex-col gap-2">
			<ContentLoader width="w-full" height="h-[50px]" />
		</div>
		<hr class="mt-4 w-full" />
	</div>
</template>

<script setup lang="ts">
import ContentLoader from '@/components/ContentLoader.vue'
import ConditionFilterToggle from '@/components/toggle/ConditionFilterToggle.vue'
import { useProductCatalog } from '@/stores/product-catalog'

const productCatalog = useProductCatalog()

const { partnerName } = useGetPartnerName()

const isDirty = computed(() => productCatalog.isDirty)

const showContentLoader = computed(() => !isDirty.value)

const {
	isConditionAll,
	isConditionNew,
	isConditionUsed,
	isFuelTypeEv,
	totalVehiclesCountLabel,
	totalNewVehiclesCountLabel,
	totalUsedVehiclesCountLabel,
	totalEvCountLabel,
} = useVehicleFilters({
	activeFilters: () => productCatalog.filters,
	facets: () => productCatalog.facets,
})

const getSelected = (conditionType: string) => {
	const conditionSelected = conditionType.toLowerCase()

	if (conditionSelected === 'all') {
		if (!partnerName.value) {
			productCatalog.updateFilter({
				filterKey: 'conditions',
				filterValue: '', // Set to empty to remove conditions only.
				overwrite: true,
			})
			return
		} else {
			productCatalog.clearFilter()
			return
		}
	}

	let params = {
		filterKey: 'conditions',
		filterValue: conditionSelected,
	}

	if (conditionSelected === 'ev only') {
		params = {
			filterKey: 'fuelTypes',
			filterValue: ['electric'] as unknown as string,
		}
	}

	productCatalog.updateFilter({ ...params, overwrite: true })
}
</script>
